import * as cartActions from './pages/Store/actions/cartActions'

const loggedInSuccess = (user) => {	
    return {	
        type : 'LOGGEDIN_SUCCESS',	
        payload : {	
            user	
        }	
    }  	
} 	
 export const loggedIn = (user) => {	
    return (dispatch, getState, getFirebase) => {	
        const firebase = getFirebase();	
        const userRef = firebase.ref().child(`accounts/${user.uid}`);	

        const { cart } = getState();

        userRef.on("value", (snapshot) => {	
            const data = snapshot.val();
            if(data) {
                let orders = [];
                if(data.orders){
                    for(var key in data.orders) {
                        orders.push(data.orders[key]);
                    }
                }

                dispatch(loggedInSuccess({	
                    uid : snapshot.key,
                    verified : user.emailVerified,
                    address : data.address,
                    company : data.company,
                    email : data.email,
                    fullName : data.fullName,
                    orders : orders,
                    phone : data.phone,
                    areaSize : data.areaSize,
                    greenhouseType : data.greenhouseType,
                    plantType : data.plantType,
                    approved : data.approved
                }))	

                if(cart && cart.length > 0){
                    dispatch(cartActions.clearCart());
                    dispatch(cartActions.setCartDB(user.uid, cart));
                } else {
                    dispatch(cartActions.loadCartDB(user.uid));
                }
            }
        })	
    }	
}	
 export const loggedOut = () => {	
     return (dispatch, getState, getFirebase) => {
         dispatch(cartActions.loadCartLocal());

         dispatch({
            type : 'LOGGED_OUT'
         })
     }

}


// WEBPACK FOOTER //
// ./src/loginActions.js